export default {
//随三个图片之一显示
randomPic:function() {
    var tagHash = [
      // cover1
      {
        //随机生成的图片
        imgUrl: "cover1.png",
      },
      // cover2
      {
        imgUrl: "cover2.png",
      },
      // cover3
      {
        imgUrl: "cover3.png",
      },
    ];
    let randomKeys = [0, 1, 2];
    let index = Math.floor(Math.random() * 3);
    return require("@/assets/imgs/"+tagHash[randomKeys[index]].imgUrl)
  },
  // 本机、内网或测试环境跳转新版测试站，否则跳转线上
  isLocalOrTestEnv: function() {
    var hostname = window.location.hostname || "";
    return (
      hostname === "localhost" ||
      hostname === "127.0.0.1" ||
      hostname.indexOf("192.168.") === 0 ||
      hostname.indexOf("192.198.") === 0 ||
      hostname.indexOf("testsearch.") === 0
    );
  },
  getNewVersionUrl: function(loginTypeName) {
    var baseUrl = this.isLocalOrTestEnv()
      ? "https://testchatopen.newacademic.net/"
      : "https://chatopen.newacademic.net/";
    return baseUrl + "?loginTypeName=" + encodeURIComponent(loginTypeName);
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js